var _g, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProducts(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1452_863)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18.9751,
    cy: 18,
    r: 16,
    fill: "#EAF9F9"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9751 14.0144C24.9751 15.6791 22.2886 17.0288 18.9751 17.0288C15.6616 17.0288 12.9751 15.6791 12.9751 14.0144M24.9751 14.0144C24.9751 12.3497 22.2886 11 18.9751 11C15.6616 11 12.9751 12.3497 12.9751 14.0144M24.9751 14.0144V22.2356C24.9751 23.9003 22.2886 25.25 18.9751 25.25C15.6616 25.25 12.9751 23.9003 12.9751 22.2356V14.0144M24.9751 14.0144V16.7548V14.0144ZM12.9751 14.0144V16.7548V14.0144ZM24.9751 16.7548V19.4952C24.9751 21.1599 22.2886 22.5096 18.9751 22.5096C15.6616 22.5096 12.9751 21.1599 12.9751 19.4952V16.7548M24.9751 16.7548C24.9751 18.4195 22.2886 19.7692 18.9751 19.7692C15.6616 19.7692 12.9751 18.4195 12.9751 16.7548",
    fill: "#2AC6C6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9751 14.0144C24.9751 15.6791 22.2886 17.0288 18.9751 17.0288C15.6616 17.0288 12.9751 15.6791 12.9751 14.0144M24.9751 14.0144C24.9751 12.3497 22.2886 11 18.9751 11C15.6616 11 12.9751 12.3497 12.9751 14.0144M24.9751 14.0144V22.2356C24.9751 23.9003 22.2886 25.25 18.9751 25.25C15.6616 25.25 12.9751 23.9003 12.9751 22.2356V14.0144M24.9751 14.0144V16.7548M12.9751 14.0144V16.7548M24.9751 16.7548V19.4952C24.9751 21.1599 22.2886 22.5096 18.9751 22.5096C15.6616 22.5096 12.9751 21.1599 12.9751 19.4952V16.7548M24.9751 16.7548C24.9751 18.4195 22.2886 19.7692 18.9751 19.7692C15.6616 19.7692 12.9751 18.4195 12.9751 16.7548",
    stroke: "#EAF9F9",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1452_863",
    x: 0.975098,
    y: 0,
    width: 36,
    height: 36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.164706 0 0 0 0 0.776471 0 0 0 0 0.776471 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1452_863"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1452_863",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProducts);
export default __webpack_public_path__ + "static/media/products.76882da2d84949f92d0e861102af6d6f.svg";
export { ForwardRef as ReactComponent };